export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1630699144565-a42d8db6da02?w=1920&q=80",
  shower: "https://images.unsplash.com/photo-1630699144565-a42d8db6da02?w=800&q=80",
  mirrors: "https://images.unsplash.com/photo-1763485957127-5645e9348426?w=800&q=80",
  commercial: "https://images.unsplash.com/photo-1769008302060-74c03f712dfb?w=800&q=80",
  window: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
  about: "https://images.unsplash.com/photo-1721564130772-c9ee561ab87b?w=800&q=80",
};

export const GALLERY_IMAGES = [
  { src: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=80", alt: "Frameless shower enclosure" },
  { src: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80", alt: "Modern bathroom design" },
  { src: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80", alt: "Window replacement" },
  { src: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&q=80", alt: "Custom mirror installation" },
  { src: "https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=800&q=80", alt: "Residential glass work" },
  { src: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80", alt: "Commercial storefront" },
];

export const TESTIMONIALS = [
  {
    quote: "Brunswick Glass transformed our master bathroom with a stunning frameless shower. The attention to detail and professionalism was outstanding.",
    author: "Sarah Mitchell",
    location: "Wilmington, NC",
    rating: 5
  },
  {
    quote: "We've used them for multiple commercial projects. Always on time, professional, and the quality of work is exceptional.",
    author: "James Reynolds",
    location: "Southport, NC",
    rating: 5
  },
  {
    quote: "The team replaced all our foggy windows and the difference is incredible. Great communication throughout the entire process.",
    author: "Linda Chen",
    location: "Oak Island, NC",
    rating: 5
  },
];

export const SERVICES = [
  {
    title: "Custom Shower Glass",
    desc: "Frameless, Semi-Frameless, & Sliding Enclosures",
    image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=80",
    large: true,
    features: ["Frameless Showers", "Semi-Frameless", "Sliding Doors"]
  },
  {
    title: "Window Replacement",
    desc: "Energy-efficient residential upgrades",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
  },
  {
    title: "Custom Mirrors",
    desc: "Vanity, Wall, and Gym Mirrors",
    image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&q=80",
  },
  {
    title: "Commercial Glass",
    desc: "Storefronts & Office Partitions",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80",
    wide: true,
  },
];

export const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};
